module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "scroll-container"
  }, [_c('div', {
    ref: "scrollContent",
    staticClass: "scroll-content"
  }, _vm._l((_vm.tickets), function(ticket, index) {
    return _c('div', {
      key: index,
      staticClass: "ticket",
      class: {
        'selected': ticket.selected
      },
      on: {
        "click": function($event) {
          _vm.handleClick(ticket)
        }
      }
    }, [_c('div', {
      staticClass: "checkbox"
    }, [(ticket.selected) ? _c('i', {
      staticClass: "n-i n-i-check-a"
    }) : _c('i', {
      staticClass: "n-i n-i-circle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "ticket-id"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("ticket id")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(ticket.id))])]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("date and time")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(ticket.createdAt))])]), _vm._v(" "), _c('div', {
      staticClass: "payin"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("payin")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(ticket.payin))])]), _vm._v(" "), _c('div', {
      staticClass: "status"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("status")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(ticket.status.name))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "controls",
    class: {
      'active': _vm.controlsActive
    }
  }, [_c('div', {
    staticClass: "down",
    on: {
      "click": function($event) {
        _vm.handleScroll({
          type: 'down'
        })
      }
    }
  }, [_c('i', {
    staticClass: "n-i n-i-arrow-down-a"
  })]), _vm._v(" "), _c('div', {
    staticClass: "to-top",
    on: {
      "click": function($event) {
        _vm.handleScroll({
          type: 'top'
        })
      }
    }
  }, [_c('i', {
    staticClass: "n-i n-i-arrow-up-a"
  }), _vm._v(" "), _c('i', {
    staticClass: "n-i n-i-arrow-up-a"
  }), _vm._v(" "), _c('span', [_vm._v("to top")])]), _vm._v(" "), _c('div', {
    staticClass: "up",
    on: {
      "click": function($event) {
        _vm.handleScroll({
          type: 'up'
        })
      }
    }
  }, [_c('i', {
    staticClass: "n-i n-i-arrow-up-a"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "print-copy",
    on: {
      "click": function($event) {
        _vm.print()
      }
    }
  }, [_c('span', [_vm._v("Print Copy")])])]), _vm._v(" "), _c('div', {
    staticClass: "overlay",
    class: {
      'active': !_vm.loaded
    }
  }, [_c('div', {
    staticClass: "loader"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30976408","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/TicketHistory.vue
// module id = 400
// module chunks = 0